import { pageNames } from "utils/Types";

export const noPlansMessageCommon = {
  [pageNames.allPlans]: {
    label: "All Plans",
    title: "No plans are currently available - that's okay.",
    content: "Check and reset your filters for a different selection.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.functionalArea]: {
    label: "All Plans",
    title: "There are no plans for this Functional Areas.",
    content: "We are always adding the most relevant content for you -continue to check back or retake the Wizard.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.searchResult]: {
    label: "All Plans",
    title: "Oh no! No plans were found with these words.",
    content: "Try different key terms, continue to check back, or retake the wizard.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.bookmarked]: {
    label: "Bookmarked",
    title: "You have no bookmarked plans. No problem!",
    content: "If you are ready for your next step, go search the Library.",
    showButton: true,
    buttonLabel: "Explore Library"
    // image: PersonSearch
  }
};
